module.exports = __webpack_public_path__ + "img/nav-right-search-below-lincoln.f2f5aa88.png";